function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["value", "onChange", "children"],
  _excluded2 = ["previewImage", "value", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import AliyunOSSUpload from "../AliyunOSSUpload";
import { compact, isEqual, uniq } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { usePrevious } from 'react-use';
import { usePreviewImage } from "./PreviewImage";
import { jsx as _jsx } from "react/jsx-runtime";
export function getSplitFilename(filename) {
  if (filename.length > 12) {
    var firstPart = filename.slice(0, -12);
    var lastPart = filename.slice(-12);
    return [firstPart, lastPart];
  }
  return [filename];
}

// 'https://xxx.xxx/aaa/bbb/ccc.ddd'
// 'https://xxx.xxx/aaa/bbb/ccc.ddd?Expires=1704188078&OSSAccessKeyId=LTAI5tDsCs7zY6UPdU5Dw9fN&Signature=IO0bQfe%2FHaCjgUoyOtrC6SqZP44%3D'
// 'https://xxx.xxx/aaa/bbb/ccc.ddd?Expires=1704188078&OSSAccessKeyId=LTAI5tDsCs7zY6UPdU5Dw9fN&Signature=IO0bQfe%2FHaCjgUoyOtrC6SqZP44%3D'
// 'https://static-test.micun.com/upload/2024/2/2/Ai2ul0goQ4gToBqxhTdYg/tmp_551375bde2021103d97bbd46d2ef3c12.jpg?x-oss-process=image/watermark,image_dXBsb2FkLzIwMjQvMi8yL3ZpTGFMX0ljLWJXaUlhdEVPLXJLVS90bXBfM2Y3OTNmNjRiYTU3OTA3Yjc4OGNmY2NiNzg1MDM3OWEucG5n,g_sw,x_36,y_100'
// 'https://static-test.micun.com/upload/2024/2/2/Ai2ul0goQ4gToBqxhTdYg/tmp_551375bde2021103d97bbd46d2ef3c12.jpg?x-oss-process=image%2Fwatermark%2Cimage_dXBsb2FkLzIwMjQvMi8yL3ZpTGFMX0ljLWJXaUlhdEVPLXJLVS90bXBfM2Y3OTNmNjRiYTU3OTA3Yjc4OGNmY2NiNzg1MDM3OWEucG5n%2Cg_sw%2Cx_36%2Cy_100'
// 'https://api.micun.com/assistant/oss/download/object/v1?objectName=upload%2F2024%2F2%2F4%2Fg-yYSK-XbmPi07xztt-YA/tmp_9600f23b4731ec58cf67f99aa8be17b9.jpg&style=image%2Fwatermark%2Cimage_dXBsb2FkLzIwMjQvMi80L1Z5b0V0Q3hZQm02MF9mS2VSMFFIMy90bXBfOWVjYzU1N2FjMjcyYTRjZTk1NjkxYmZjYzRiMDQ0OGQucG5n%2Cg_sw%2Cx_60%2Cy_60'
// 'https://api.micun.com/assistant/oss/download/object/v1?objectName=upload%2F2024%2F2%2F4%2Fg-yYSK-XbmPi07xztt-YA%2Ftmp_9600f23b4731ec58cf67f99aa8be17b9.jpg&style=image%2Fwatermark%2Cimage_dXBsb2FkLzIwMjQvMi80L1Z5b0V0Q3hZQm02MF9mS2VSMFFIMy90bXBfOWVjYzU1N2FjMjcyYTRjZTk1NjkxYmZjYzRiMDQ0OGQucG5n%2Cg_sw%2Cx_60%2Cy_60'
// 'https://api.micun.com/assistant/oss/download/object/v1?objectName=upload%2F2024%2F2%2F19%2F%2F%E5%8C%97%E4%BA%AC%E7%86%99%E6%82%A6%E9%BE%99%E6%B9%96%E4%BA%8C%E5%BA%9712.1%E6%96%B0%E7%89%88%E6%8A%A5%E5%BA%97%E8%B5%84%E6%96%99_100651.pptx'
export function getFilename(url) {
  var _results$;
  if (!url) return '';
  url = url.trim();
  var segments = url.split('?');
  var groups = segments.map(function (s) {
    var _s$split$pop, _ext, _name;
    var base = ((_s$split$pop = s.split('\\').pop()) === null || _s$split$pop === void 0 ? void 0 : _s$split$pop.split('/').pop()) || '';
    if (!base) return [''];
    var str = decodeURIComponent(base);
    var idx = str.lastIndexOf('.');
    if (idx === -1) {
      return [str, undefined];
    }
    var _ref = [str.slice(0, idx), str.slice(idx + 1)],
      name = _ref[0],
      ext = _ref[1];
    ext = (_ext = ext) === null || _ext === void 0 || (_ext = _ext.split('&')[0]) === null || _ext === void 0 ? void 0 : _ext.split('?')[0];
    name = ((_name = name) === null || _name === void 0 || (_name = _name.split('=').pop()) === null || _name === void 0 ? void 0 : _name.split('/').pop()) || '';
    return [name, ext];
  });
  var results = groups.filter(function (group) {
    return group[0] && group[1];
  });
  var filename = (results[0] ? (_results$ = results[0]) === null || _results$ === void 0 ? void 0 : _results$.join('.') : groups[0][0]) || '';
  return filename;
}
export function getExtName(url) {
  if (!url) return '';
  var filename = getFilename(url);
  var suffix = filename.split('.').pop();
  if (!suffix) return '';
  return suffix.split('&')[0].toLowerCase();
}
export var Upload = function Upload(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange,
    children = _ref2.children,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var prevValue = usePrevious(value);
  var _useState = useState(new Map()),
    _useState2 = _slicedToArray(_useState, 2),
    orgValMap = _useState2[0],
    setOrgValMap = _useState2[1];

  // value + 组件上传内容融合去重后的的 url 数组
  var boxedValue = useMemo(function () {
    var nestedValue = uniq([].concat(_toConsumableArray(value || []), _toConsumableArray(orgValMap.keys())));
    // console.log('nestedValue', nestedValue)
    var result = nestedValue.map(function (url) {
      return orgValMap.get(url) || {
        uid: url,
        name: getFilename(url) || url,
        url: url,
        status: 'done'
      };
    });
    if (!isEqual(prevValue, nestedValue)) {
      // 相同路径会被去重
      result = nestedValue.map(function (url) {
        return orgValMap.get(url) || {
          uid: url,
          name: getFilename(url) || url,
          url: url,
          status: 'done'
        };
      });
      // console.log('更新', nestedValue, result)
    }
    var hasAllDoneFiles = _toConsumableArray(orgValMap.values()).every(function (i) {
      return i.status === 'done';
    });
    // 当 value 为空 + orgValMap 中全部为 done 状态的文件时, 即为清空
    if (!(value !== null && value !== void 0 && value.length) && hasAllDoneFiles) {
      // console.log('清空')
      result = [];
    }
    // console.log({ value, hasAllDoneFiles, nestedValue, result })
    return result;
  }, [prevValue, orgValMap, value]);
  var handleChange = function handleChange(files) {
    // console.log('onChange', files)
    var nextOrgValMap = new Map();
    files.forEach(function (i) {
      var key = i.url;
      if (key) {
        nextOrgValMap.set(key, i);
      }
    });
    var uploadedFiles = files.filter(function (i) {
      return i.status === 'done';
    });
    var nextValue = compact(uploadedFiles.map(function (i) {
      return i.url;
    }));
    setOrgValMap(nextOrgValMap);
    if (nextValue.length === files.length) {
      onChange === null || onChange === void 0 || onChange(nextValue);
    }
  };
  return /*#__PURE__*/_jsx(AliyunOSSUpload, _objectSpread(_objectSpread({}, otherProps), {}, {
    value: boxedValue,
    onChange: handleChange,
    children: otherProps.maxCount && boxedValue && otherProps.maxCount <= boxedValue.length ? null : children
  }));
};
export var UploadTransformValue = function UploadTransformValue(input, output) {
  return function (props) {
    var previewImage = props.previewImage,
      value = props.value,
      _onChange = props.onChange,
      rest = _objectWithoutProperties(props, _excluded2);
    var onPreview = usePreviewImage(); // eslint-disable-line
    return /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, rest), {}, {
      value: input(value),
      onPreview: previewImage ? function (file) {
        onPreview(file.url);
      } : undefined,
      onChange: function onChange(value) {
        return _onChange === null || _onChange === void 0 ? void 0 : _onChange(output(value));
      }
    }));
  };
};
export var UploadWithFilename = UploadTransformValue(function (data) {
  return (data || []).map(function (i) {
    return i.url;
  });
}, function (urls) {
  return urls.map(function (url) {
    return {
      url: url,
      name: getFilename(url)
    };
  });
});
export var UploadSingleWithFileName = UploadTransformValue(function (data) {
  return data ? [data.url] : [];
}, function (urls) {
  if (urls && urls.length) {
    return {
      url: urls[0],
      name: getFilename(urls[0])
    };
  }
  return undefined;
});
export var UploadSingleWithFileNameInLine = function UploadSingleWithFileNameInLine(props) {
  useEffect(function () {
    setValue(props.value);
  }, [props.value]);
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var onChange = function onChange(v) {
    setValue([v]);
    props.onChange && props.onChange([v]);
  };
  return /*#__PURE__*/_jsx(UploadSingleWithFileName, _objectSpread(_objectSpread({}, props), {}, {
    maxCount: 1,
    value: value ? value[0] : undefined,
    onChange: onChange,
    children: props.disabled ? null : /*#__PURE__*/_jsx("span", {
      style: {
        color: '#4C65ED',
        cursor: 'pointer'
      },
      children: "\u4E0A\u4F20"
    })
  }));
};
export var UploadSingle = UploadTransformValue(function (data) {
  return data ? [data] : [];
}, function (urls) {
  if (urls && urls.length) {
    return urls[0];
  }
  return undefined;
});
export default Upload;